
const apiConfig = {
                       baseURL: "https://api.bajizone.live",
                    //  baseURL: "http://localhost:5000",
                  };

export default apiConfig;